import React from 'react';
import { PaneManagementContext } from '../../contexts/PaneManagementContext';
import {useHelpStore} from '../Help/HelpStore';

export default function PaneManagementProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isPaneExpaneded, setIsPaneExpanded] = React.useState(false);
  const [openPanes, setOpenPanes] = React.useState<string[]>(() => {
    let paneString = localStorage.getItem('openPanes') || '[]';
    const panes = JSON.parse(paneString);
    return panes as string[];
  });
  
  const [ctaPane, setCtaOpenPane] = React.useState<any>();
  const [cdkuPane, setCdkuOpenPane] = React.useState<any>(); 
  const [isCdkuUrl, setisCdkuUrl] = React.useState<any>(); 
  const setCurrentAppInView = useHelpStore((state:any) => state.setCurrentAppInView);

  const [activePane, setActivePane] = React.useState<string | null>(() => {
    const active = localStorage.getItem('activePane');
    return active as string;
  });

  const toggleIsPaneExpanded = (isExpanded?: boolean) =>
    setIsPaneExpanded(isExpanded === undefined ? !isPaneExpaneded : isExpanded);

  React.useEffect(() => {
    localStorage.setItem('openPanes', JSON.stringify(openPanes));
  }, [openPanes]);

  const closePane = (paneId: string) => {
    const openedPanes = JSON.parse(localStorage.getItem('openPanes') ?? '[]');
    setOpenPanes(openedPanes?.filter((pane: string) => paneId !== pane));
    activePane === paneId && setActivePaneToLocalStorage('');
  };

  const clearOpenPanes = () => {
    setOpenPanes([]);
  };

  // making the assumption here that multiple instances of the same workflow are allowed

  const setActivePaneToLocalStorage = (pane: string) => {
    localStorage.setItem('activePane', JSON.stringify(pane));
  };

  const setActiveCdkuToLocalStorage = (url: string) => {
    localStorage.setItem('activeCdkuUrl', JSON.stringify(url));
  };

  const openPane = (pane: string) => {
    const updatedPanes = openPanes.filter((p) => p !== pane);
    const uniquePanes = new Set([...updatedPanes, pane]);
    setOpenPanes(Array.from(uniquePanes.values()));
    setActivePaneToLocalStorage(pane);
    setActiveCdkuToLocalStorage('');
    setCtaOpenPane(null);
    setCdkuOpenPane(null);
    setActivePane(pane);
    toggleIsPaneExpanded(true);
    setCurrentAppInView(pane);
    localStorage.setItem('activePaneLoaded', JSON.stringify(pane));
    window.dispatchEvent(new Event('active-pane-changed'));
  };

  const openCdkuPane = (pane: string, url:string) => {
    const updatedPanes = openPanes.filter((p) => p !== pane);
    const uniquePanes = new Set([...updatedPanes, pane]);
    setOpenPanes(Array.from(uniquePanes.values()));
    setActivePaneToLocalStorage(pane);
    setActiveCdkuToLocalStorage(url);
    setCdkuOpenPane(url);
    setActivePane('CDKU');
    toggleIsPaneExpanded(true);
  }

  const openCtaPane = (url: string, id: string = '0') => {
    localStorage.setItem('activePaneLoaded', JSON.stringify(id));
    setCtaOpenPane(null);
   
    setTimeout(() => {
      setCtaOpenPane(url);
      setActivePane('ctapane');
      toggleIsPaneExpanded(true);
    }, 0);
  };

  return (
    <PaneManagementContext.Provider
      value={{
        openPane,
        openPanes,
        clearOpenPanes,
        activePane,
        setActivePane,
        closePane,
        isPaneExpaneded,
        openCtaPane,
        ctaPane,
        toggleIsPaneExpanded,
        cdkuPane,
        openCdkuPane,
        isCdkuUrl,
        setisCdkuUrl,
      }}
    >
      {children}
    </PaneManagementContext.Provider>
  );
}
